import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Config from "./../../config";
import BasePortableText from "@sanity/block-content-to-react";
import Img from "gatsby-image";
import { getFluidGatsbyImage } from "gatsby-source-sanity";

// TODO: pull out images
// some of this code is from here: https://www.gatsbyjs.org/packages/gatsby-source-sanity/#using-images

const PortableText = ({ blocks }) => {
  const imageData = useStaticQuery(graphql`
    query imageQuery {
      allSanityImageAsset {
        nodes {
          url
          localFile(width: 600) {
            publicURL
            childImageSharp {
              fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `).allSanityImageAsset.nodes;

  const serializers = {
    types: {
      image: ({ node }) => {
        const imageId = node.asset.id;
        let fluidProps = getFluidGatsbyImage(
          imageId,
          { maxWidth: 600 },
          Config.sanity
        );

        let theUrls = imageData.map((x) => x.url);
        for (let i = 0; i < theUrls.length; i++) {
          if (theUrls[i].indexOf(node.asset.assetId) > -1) {
            fluidProps = imageData[i].localFile.childImageSharp.fluid;
          }
        }
        // console.log(fluidProps);
        return <Img fluid={fluidProps} />;
      },
    },
  };

  return (
    <BasePortableText
      blocks={blocks}
      serializers={serializers}
      {...Config.sanity}
    />
  );
};

export default PortableText;
